/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

import React from 'react';
import { Card, CardContent, CardHeader, makeStyles } from '@material-ui/core';
import { Trans, useTranslation } from 'react-i18next';
import { Alert } from '@material-ui/lab';
import { uiSchemaProperties } from '../../../shared/enums/uiSchemaProperties';
import useSubmission from '../useSubmission';

const useStyles = makeStyles(theme => ({
  root: {
    background: theme.palette.elementBackground,
    paddingLeft: '3.6rem',
    paddingRight: '3.6rem',
    paddingBottom: '3.6rem',
    maxWidth: '70%',
    boxShadow: 'none',
    borderRadius: '1rem',
  },
  innerContent: {
    background: theme.palette.white,
    borderRadius: '1rem',
  },
  alertInfoContainer: {
    marginTop: '2rem',
    backgroundColor: theme.palette.elementBackground,
  },
  header: {
    paddingTop: '2.3rem',
    '& span': {
      fontWeight: 'bold',
      fontSize: '1.38rem',
    },
  },
}));

export default function RFTokenField(props) {
  const { uiSchema, schema } = props;
  const { submission } = useSubmission();
  const classes = useStyles();
  const { t } = useTranslation();

  const infoMessage = uiSchema[uiSchemaProperties.UI_INFO_MESSAGE];
  const { showInfoMessage = false, enableRFToken = true } = uiSchema;

  return (
    <Card className={classes.root}>
      <CardHeader title={t(schema.title)} className={classes.header} />
      <CardContent className={classes.innerContent}>
        {uiSchema?.entries?.map((element, index) => (
          <div key={index}>
            <p>
              {element?.key}
              : &nbsp;
              <strong>{element?.value}</strong>
            </p>
          </div>
        ))}
        {enableRFToken && (
          <p>
            <Trans i18nKey="Rf.Token.wireTransfer" />
            : &nbsp;
            <strong>{submission?.rfToken}</strong>
          </p>
        )}
      </CardContent>
      {showInfoMessage && (
        <div id="info">
          {showInfoMessage && (
            <Alert id="alert-info" variant="outlined" severity="info" className={classes.alertInfoContainer}>
              <Trans i18nKey={infoMessage} />
            </Alert>
          )}
        </div>
      )}
    </Card>
  );
}
